module.exports = __webpack_public_path__ + "img/22.bfdd8599.jpg";